import { ReactNode } from "react";
import { DRAWER_CONTEXT } from "@models/DrawerContext";

export interface DrawerFormProps {
  handleClose: () => void;
}

export interface DrawerFormEntry {
  /** Header shown at the top of the drawer. */
  title: string;
  /** Renders the feature's form. Receives the host's guarded close handler. */
  render: (props: DrawerFormProps) => ReactNode;
}

const registry = new Map<DRAWER_CONTEXT, DrawerFormEntry>();

/**
 * Registers a feature's form for a drawer context. Called from the
 * `core/drawers` composition root — the one place allowed to import features —
 * so the generic drawer host (and `shared/`) never depend on `features/`.
 */
export function registerDrawerForm(
  context: DRAWER_CONTEXT,
  entry: DrawerFormEntry
): void {
  registry.set(context, entry);
}

export function getDrawerForm(
  context: DRAWER_CONTEXT
): DrawerFormEntry | undefined {
  return registry.get(context);
}
